const canonicalize = (value) => {
  if (Array.isArray(value)) return value.map(canonicalize);
  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        if (value[key] !== undefined) result[key] = canonicalize(value[key]);
        return result;
      }, {});
  }
  return value;
};

const hashString = (value, seed) => {
  let hash = seed >>> 0;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  return hash.toString(16).padStart(8, "0");
};

const normalizeExtra = (extra = {}) => ({
  id: extra?.id ?? null,
  name: String(extra?.name ?? extra?.label ?? ""),
  quantity: Number(extra?.quantity ?? extra?.qty ?? 1) || 1,
  price: Number(extra?.price ?? extra?.unit_price ?? extra?.unitPrice ?? 0) || 0,
  type: String(extra?.type ?? extra?.kind ?? ""),
});

const normalizeDraftLine = (item = {}, index = 0) => {
  const clientLineId = String(item?.client_line_id ?? item?.clientLineId ?? "");
  return {
  clientLineId,
  fallbackLineKey: clientLineId
    ? ""
    : String(item?.itemKey ?? `position-${index}`),
  productId: item?.productId ?? item?.product_id ?? item?.id ?? item?.product?.id ?? null,
  quantity: Number(item?.quantity ?? item?.qty ?? 1) || 1,
  unitPrice:
    Number(
      item?.unitPrice ??
        item?.unit_price ??
        item?.price ??
        item?.product_price ??
        0,
    ) || 0,
  destination: String(item?.destination ?? ""),
  variationId: item?.variationId ?? item?.variation_id ?? null,
  variationName: String(
    item?.variationName ?? item?.variation_name ?? item?.variationLabel ?? "",
  ),
  variationAttributes:
    item?.variationAttributes ?? item?.variation_attributes ?? null,
  extras: (Array.isArray(item?.extras) ? item.extras : [])
    .map(normalizeExtra)
    .sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right))),
  };
};

/**
 * Builds a deterministic request id for one exact draft batch.
 * Repeated taps and retries reuse the same id, while any cart mutation produces
 * another id. The server keeps the completed response for seven days.
 */
export const buildOrderSendRequestId = ({
  operation = "send",
  deviceId,
  tableId,
  orderId = null,
  items = [],
}) => {
  const payload = canonicalize({
    operation: String(operation),
    deviceId: String(deviceId || "unknown-device"),
    tableId: String(tableId ?? "no-table"),
    orderId: orderId == null ? null : String(orderId),
    items: (Array.isArray(items) ? items : [])
      .map(normalizeDraftLine)
      .sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right))),
  });
  const serialized = JSON.stringify(payload);
  const digest = [2166136261, 2246822519, 3266489917, 668265263]
    .map((seed) => hashString(serialized, seed))
    .join("");
  return `cart-${String(operation)}-${digest}`;
};
